import React, { Fragment } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import { ACL } from '../../../../../../../config/constants/UogACL/ACL';

function ManageGroup(props) {
  const {
    index,
    group,
    showIcon,
    addUserInGroup,
    removeUserFromGroup,
    displayUsersGroup
  } = props;

  if (! ACL.ADMIN.GROUPS.SYNC_USERS.hasAccess()) {
    return null;
  }

  return ( <Fragment>
      {! showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={displayUsersGroup ? ( 'remove-group-' + index ) : ( 'add-group-' + index )}
            onClick={e => {
              e.preventDefault();
              displayUsersGroup ?
                removeUserFromGroup( group, index ) :
                addUserInGroup( group, index );
            }}
          >
            {
              displayUsersGroup ?
                <FormattedMessage
                  id="components.pages.admin.tabs.groups_list.actionButtons.remove_group"/> :
                <FormattedMessage
                  id="components.pages.admin.users.buttons.create_group"/>
            }
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={displayUsersGroup ? ( 'remove-group-' + index ) : ( 'add-group-' + index )}
            modifiers={{
              preventOverflow: {
                enabled: true,
                boundariesElement: "body",
              },
            }}
          >
            {
              displayUsersGroup ?
                <FormattedMessage
                  id="components.pages.admin.tabs.groups_list.actionButtons.remove_group"/> :
                <FormattedMessage
                  id="components.pages.admin.users.buttons.create_group"/>
            }
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={displayUsersGroup ? ( 'remove-group-' + index ) : ( 'add-group-' + index )}
            onClick={e => {
              e.preventDefault();
              displayUsersGroup ?
                removeUserFromGroup( group, index ) :
                addUserInGroup( group, index );
            }}
          >
            <FontAwesomeIcon
              size="lg"
              className="align-middle cursor-pointer"
              pointerEvents="none"
              icon={displayUsersGroup ? faMinusCircle : faPlusCircle}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={displayUsersGroup ? ( 'remove-group-' + index ) : ( 'add-group-' + index )}
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
          >
            {
              displayUsersGroup ?
                <FormattedMessage
                  id="components.pages.admin.tabs.groups_list.actionButtons.remove_group"/> :
                <FormattedMessage
                  id="components.pages.admin.users.buttons.create_group"/>
            }
          </UncontrolledTooltip>
        </Fragment>
      }
    </Fragment>
  );
}

export { ManageGroup };
